import { Injectable } from '@angular/core';
import { OTPSuccessServerResponse } from 'src/app/views/sign-in/sign-in.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private authInfo?: OTPSuccessServerResponse;

  constructor() {}

  setAuthInfo(info: OTPSuccessServerResponse) {
    this.authInfo = { ...info };
  }

  getAuthInfo(): OTPSuccessServerResponse | undefined {
    return this.authInfo;
  }

  getAccessToken(): string | undefined {
    return this.authInfo?.accessToken;
  }
}
